import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { statusColor } from '@platform/core/lib/statusColors';
import type { IRecordTypeDefinition } from '@platform/core/types';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IPickerOption } from '@platform/ui';
import { canMoveStatus } from './statusTransitions';

/**
 * Пункти пікера статусу (прототип fieldItems: статус без «Не вказано»), підписи й крапки — за визначенням типу; з `current` пункти,
 * до яких перейти не можна (правило переходів, як у TransitionPolicy бекенду), вимкнені з причиною в підказці.
 */
export function useStatusOptions(rt: IRecordTypeDefinition): (current?: string | null) => IPickerOption[] {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  return useCallback((current) => {
    const from = current ? strings.status(rt.key, current, current) : '';
    return rt.statuses.list.map((s) => {
      const label = strings.status(rt.key, s.value, s.label);
      const allowed = canMoveStatus(rt.statuses, current, s.value);
      return { value: s.value, label, dot: statusColor(rt.statuses, s.value, rt.key), disabled: !allowed, title: allowed ? undefined : t('recordPage.transitionDenied', { from, to: label }) };
    });
  }, [rt, strings, t]);
}
